import { useSelector } from 'react-redux';
import TabPanel from 'components/presentational/TabPanel';

/**
 * Hot fix component to solve Multichild problem with its tabs children
 * Archive when Multichild is replaced totally
 * @param {Object} props
 * @param {number} props.index
 * @param {'all' | number} props.breadcrumb
 * @param {React.JSX.Element} props.children
 * @return React.JSX.Element
 * */
function TabPanelWrapper({ index, breadcrumb, children }) {
    const { pathname } = useSelector((state) => state.url);
    const isNumberBlockPage = pathname.includes('number-blocks');

    if (isNumberBlockPage) {
        return (
            <div
                style={{
                    display: breadcrumb === index ? 'block' : 'none',
                    width: '100%',
                }}>
                {children}
            </div>
        );
    } else {
        return (
            <TabPanel index={index} value={breadcrumb}>
                {children}
            </TabPanel>
        );
    }
}

export default TabPanelWrapper;
